import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "report-history" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" History ")
const _hoisted_3 = { class: "report-history__headings row" }
const _hoisted_4 = { class: "report-history__content-title cell heading col-4 col-md-3" }
const _hoisted_5 = { class: "report-history__content-time cell col-4 col-md-4" }
const _hoisted_6 = { class: "report-history__content-elapsed cell col-4 col-md-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReportSectionHeader = _resolveComponent("ReportSectionHeader")!
  const _component_GenericTableHeaderButton = _resolveComponent("GenericTableHeaderButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ReportSectionHeader, {
      onFilterToggled: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleAccordion())),
      isOpen: _ctx.isOpen
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["isOpen"]),
    _createElementVNode("div", {
      class: _normalizeClass(["report-history__content-container", { open: _ctx.isOpen }])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_GenericTableHeaderButton, {
          class: "status-heading",
          label: "Status",
          sortable: false
        }),
        _createVNode(_component_GenericTableHeaderButton, {
          class: "time-date-heading",
          label: "Time / Date",
          sortable: false
        }),
        _createVNode(_component_GenericTableHeaderButton, {
          class: "elapsed-heading",
          label: "Elapsed Time (HH:MM:SS)",
          sortable: false
        })
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historyItems, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "report-history__content row",
          key: item.label
        }, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(item.label), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(item.time.value), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(item.elapsedTime.value), 1)
        ]))
      }), 128))
    ], 2)
  ]))
}